import { useContext } from "react";
import { userContext } from '../../contexts/userContext';
import CalendarWidget from "../schedule/CalendarWidget";
import { ProjectsWidget } from "../projects/ProjectsWidget";
import { useUserProjects } from "../../hooks/db"; // Import the function to get projects
import { Loader } from 'lucide-react';
import Unpaid from "../income/Unpaid";
import { Link } from "react-router-dom";

// Component: Dashboard
const Dashboard = () => {

    const user_id = useContext(userContext);
    const userProjects = useUserProjects(user_id[0]); // Use the custom hook
    // console.log("User Projects: ", userProjects);

    // Render the component
    return (
        <div id="dashboard" className="flex flex-col m-auto px-10 max-w-[1200px] self-center">
            <div id="dashboardTopRow" className="flex pt-2 pb-3 px-4 my-5 rounded-xl flex flex-col">
                <div className="uppercase text-[8px] text-[#aaa] font-semibold tracking-wider">
                    Quick Actions
                </div>
                <div>
                    <Link to="createproject" id="newProjectLink" className="w-[200px] mr-[195px]">
                        <button className="py-0 px-2 flex-left bg-[#ffee00] rounded-md uppercase font-semibold text-sm text-[black] hoverUp hover:text-[#666]">
                            + create new project
                        </button>
                    </Link>
                </div>

            </div>
            <div id="dashboardBottomRow" className="flex flex-col justify-between gap-4 lg:flex-row">
                 {/* justify-between */}
                <div id="dashboardLeft" className="flex flex-col gap-4 items-center">
                    <div id="projectWidgetTray" className="gradientBG px-5 py-5 min-h-[250px] max-h-[600px] w-[350px]">
                        <ProjectsWidget projects={userProjects}/>
                    </div>

                </div>
                <div id="dashboardRight" className="flex flex-col gap-4 items-center">
                    {userProjects ? (
                        <div>
                            <CalendarWidget projects={userProjects}/>
                        </div>
                    ) : (
                        <div id="calendarWidget" className="gradientBG">
                            <h3><Loader className="spinning"/></h3>
                        </div>
                    )}
                        <div className="gradientBG m-auto px-5 py-5 min-h-[250px] max-h-[600px] w-[400px]">
                            <Unpaid projects={userProjects}/>
                        </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;